import script from "./UploadInput.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadInput.vue?vue&type=script&setup=true&lang=js"

import "./UploadInput.vue?vue&type=style&index=0&id=35d9f318&lang=scss"

const __exports__ = script;

export default __exports__